import React, {useEffect} from "react";
import {Card} from "react-bootstrap";
import {Link} from "react-router-dom";
import {LOGIN_ROUTE, REGISTRATION_ROUTE} from "../../utils/consts";

const DevHomeFallback = () => {
    const isLocalSpa = ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);

    useEffect(() => {
        if (!isLocalSpa) {
            window.location.replace("/");
        }
    }, [isLocalSpa]);

    if (!isLocalSpa) {
        return (
            <Card className="p-3 w-100 mt-2">
                <h5 className="text-muted mb-2">Opening Virtalibry</h5>
                <p className="text-muted small mb-0">Redirecting to the public home page...</p>
            </Card>
        );
    }

    return (
        <Card className="p-3 w-100 mt-2">
            <h5 className="text-muted mb-2">Virtalibry SPA development shell</h5>
            <p className="text-muted small mb-2">
                The public home page is served by Astro. This React route exists only as a local SPA fallback.
            </p>
            <div className="d-flex flex-wrap gap-2">
                <Link className="btn btn-sm btn-outline-success" to={LOGIN_ROUTE}>
                    Sign in
                </Link>
                <Link className="btn btn-sm btn-success" to={REGISTRATION_ROUTE}>
                    Sign up
                </Link>
            </div>
        </Card>
    );
};

export default DevHomeFallback;
